import { APIResponse } from './api-response.type';

export enum ToastType {
  ERROR = 'error',
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
}

export interface ToastInfo {
  isOpen: boolean;
  type?: ToastType;
  message: string;
}

export enum StatusValues {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending',
  DELETED = 'deleted',
}

export enum LeadStatusValues {
  ACTIVE = 'active',
  DELETED = 'deleted',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export interface ImageUploadResponse extends APIResponse {
  data: {
    name: string;
    url: string;
  };
}

export interface PaymentLinkResponse extends APIResponse {
  data: {
    paymentData: any;
  };
}

export interface UniqueFieldResponse extends APIResponse {
  data: {
    // userId?: string;
    // mentorId?: string;
    // teamId?: string;
    // supportId?: string;
    // partnerId?: string;
    id?: string;
  };
}

export interface StatsResponse extends APIResponse {
  data: {
    userCount: number;
    userComparision?: number;
    qaCount: number;
    qaComparision?: number;
    agentCount?: number;
    assistantCount?: number;
  } | null;
}

export enum ChatModels {
  CHAT_GPT_4_TURBO = 'gpt-4-turbo',
  CHAT_GPT_3_5_TURBO = 'gpt-3.5-turbo',
  CHAT_GPT_4_O = 'gpt-4o',
  CHAT_GPT_4_O_MINI = 'gpt-4o-mini',
  CHAT_GPT_4 = 'gpt-4',
  CLAUDE_3_5_SONNET = 'claude-3-5-sonnet-20240620',
  CLAUDE_3_OPUS = 'claude-3-opus-20240229',
  CLAUDE_3_HAIKU = 'claude-3-haiku-20240307',
  PERPLEXITY_LLAMA_3_1_8B_INSTRUCT = 'llama-3.1-8b-instruct',
  PERPLEXITY_LLAMA_3_1_70B_INSTRUCT = 'llama-3.1-70b-instruct',
}

export type PromptAnalytics = {
  promptQuality: number;
  promptQueryComplexity: string;
  totalTokens: number;
}

export type ChatMsg = {
  _id: string;
  msgId?: string;
  isGoodResponse?: boolean;
  files?: string[];
  question: string;
  answer: string;
  inputTokens: number;
  outputTokens: number;
  promptAnalytics?: PromptAnalytics;
  model: ChatModels;
  createdAt: string;
};

export enum OrgUserRole {
  USER = 'User',
  ADMIN = 'Admin',
  SUPER_ADMIN = 'Superadmin',
}
